import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { OrganizationSchema, WebSiteSchema, WebPageSchema, FAQPageSchema } from '@/components/base/SeoSchema';

const faqItems = [
  {
    question: '51在线吃瓜是什么？',
    answer: '51在线吃瓜是一站式娱乐资讯聚合平台，聚合全网最新明星八卦、网红爆料、社会热点等内容，提供吃瓜视频在线观看和51在线吃瓜app下载服务，是吃瓜群众获取最新娱乐资讯的首选入口。',
  },
  {
    question: '51在线吃瓜app如何下载？',
    answer: '您可以通过本网站首页的"下载APP"按钮获取51在线吃瓜app下载链接，支持iOS和Android双平台。下载后即可随时随地浏览最新吃瓜资讯、观看吃瓜视频，不错过任何热点爆料。',
  },
  {
    question: '51在线吃瓜的内容来源是什么？',
    answer: '51在线吃瓜的内容来源于微博、抖音、豆瓣、小红书等主流社交平台的公开信息，由专业编辑团队进行整理、核实后发布。我们坚持多重信源交叉验证，确保内容的真实性和可靠性。',
  },
  {
    question: '如何在51在线吃瓜上找到最新地址？',
    answer: '51在线吃瓜的官方网址为 www.smallbar.cn，您可以将此网址添加到浏览器收藏夹。同时建议下载51在线吃瓜app，避免因网址变更而无法访问。我们也会通过官方微博和微信公众号及时发布最新地址信息。',
  },
  {
    question: '如何联系51在线吃瓜进行商务合作？',
    answer: '您可以通过本网站关于我们页面的商务合作表单提交合作需求，也可以发送邮件至 hello@smallbar.cn，或拨打客服热线 400-888-5151。我们将在24小时内回复您的合作需求。',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      const response = await fetch('http://smallbar.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (response.ok && parsed && (parsed as Record<string, string>).code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = (parsed as Record<string, string>)?.meta?.message
          || (parsed as Record<string, string>)?.message
          || (parsed as Record<string, string>)?.meta?.detail
          || responseText
          || '提交失败，请稍后重试';
        setFormError(serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  const advantages = [
    {
      icon: 'ri-shield-check-line',
      title: '权威可信',
      description: '多重信源交叉验证，确保每一条吃瓜资讯的真实性与可信度，为吃瓜群众提供值得信赖的内容。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速更新',
      description: '7×24小时不间断追踪全网热点，第一时间为您推送最新最热的明星八卦与网红爆料。',
    },
    {
      icon: 'ri-global-line',
      title: '全网聚合',
      description: '聚合微博、抖音、豆瓣、小红书等主流平台的所有吃瓜内容，一个入口看遍全网瓜田。',
    },
  ];

  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="关于我们 - 51在线吃瓜 | 品牌介绍与商务合作"
        description="51在线吃瓜是国内领先的一站式娱乐资讯聚合平台，服务超过5000万用户。了解品牌故事、平台优势及商务合作联系方式。"
        url="http://smallbar.cn/about"
      />
      <FAQPageSchema questions={faqItems} />
      <Navbar />
      <main>
        {/* Brand Story */}
        <section className="w-full pt-28 pb-16 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <div className="w-20 h-20 mx-auto mb-8 flex items-center justify-center rounded-2xl bg-primary-500">
              <i className="ri-emotion-happy-line text-4xl text-background-50"></i>
            </div>
            <p className="text-foreground-500 text-sm mb-4">关于 51 在线吃瓜</p>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-8">
              做全网最懂吃瓜群众的
              <br />
              娱乐资讯平台
            </h1>
            <div className="text-foreground-700 text-base md:text-lg leading-relaxed space-y-4">
              <p>
                51在线吃瓜成立于2023年，是国内领先的一站式娱乐资讯聚合平台。我们致力于为亿万吃瓜群众提供最新、最全、最靠谱的娱乐圈动态追踪服务。
              </p>
              <p>
                从明星八卦到网红爆料，从综艺幕后到影视剧透，从社会热点到黑料实锤——51在线吃瓜入口聚合全网资源，让你不错过任何一个值得关注的瓜。我们的编辑团队7×24小时不间断监测各大社交平台，以最快的速度将新鲜热辣的吃瓜内容呈现给你。
              </p>
              <p>
                平台上线以来，已累计服务超过5000万吃瓜用户，日均更新文章超过200篇，全网热搜覆盖率高达95%。无论是51在线吃瓜网站、51吃瓜官网全网最新资讯，还是51在线吃瓜app下载与吃瓜视频在线观看，我们都为你提供最便捷的入口体验。
              </p>
            </div>
          </div>
        </section>

        {/* Platform Stats */}
        <section className="w-full py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { value: '5000万+', label: '累计用户' },
                { value: '200+', label: '日均更新' },
                { value: '95%', label: '热搜覆盖率' },
                { value: '6大', label: '内容分类' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-6 bg-background-100 rounded-lg">
                  <div className="text-2xl md:text-3xl font-heading text-primary-500 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-foreground-600 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Advantages */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-10">
              <span className="text-foreground-500 text-xs font-medium tracking-wider uppercase">
                平台优势
              </span>
              <h2 className="text-3xl md:text-4xl font-heading text-foreground-950 leading-tight mt-2">
                为什么选择
                <br />
                51在线吃瓜
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {advantages.map((adv) => (
                <div key={adv.title} className="bg-background-50 rounded-lg p-6">
                  <div className="w-12 h-12 flex items-center justify-center mb-4">
                    <i className={`${adv.icon} text-3xl text-foreground-800`}></i>
                  </div>
                  <h3 className="text-lg font-medium text-foreground-950 mb-3">
                    {adv.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {adv.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section with visible content */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="mb-10">
              <span className="text-foreground-500 text-xs font-medium tracking-wider uppercase">
                常见问题
              </span>
              <h2 className="text-3xl md:text-4xl font-heading text-foreground-950 leading-tight mt-2">
                你关心的
                <br />
                都在这里
              </h2>
            </div>
            <div className="space-y-4">
              {faqItems.map((faq) => (
                <details key={faq.question} className="bg-background-100 rounded-lg p-5 group cursor-pointer">
                  <summary className="flex items-center justify-between text-foreground-950 font-medium text-sm md:text-base">
                    {faq.question}
                    <i className="ri-arrow-down-s-line text-lg text-foreground-400 transition-transform group-open:rotate-180"></i>
                  </summary>
                  <p className="text-foreground-600 text-sm leading-relaxed mt-3 pt-3 border-t border-background-200/70">
                    {faq.answer}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Business Cooperation */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="text-foreground-500 text-xs font-medium tracking-wider uppercase">
                商务合作
              </span>
              <h2 className="text-3xl md:text-4xl font-heading text-foreground-950 leading-tight mt-2">
                联系我们
              </h2>
              <p className="text-foreground-600 mt-4 max-w-lg mx-auto">
                欢迎品牌合作、广告投放、内容授权等商务洽谈，请填写以下表单，我们将在24小时内回复。
              </p>
            </div>

            <form
              onSubmit={handleSubmit}
             
              id="contact-form"
              className="bg-background-100 rounded-lg p-6 md:p-8 space-y-5"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="name" className="block text-foreground-700 text-sm font-medium mb-2">
                    姓名 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-foreground-700 text-sm font-medium mb-2">
                    邮箱 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="company" className="block text-foreground-700 text-sm font-medium mb-2">
                  公司名称
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                  placeholder="请输入您的公司名称"
                />
              </div>

              <div>
                <label htmlFor="cooperation_type" className="block text-foreground-700 text-sm font-medium mb-2">
                  合作类型 <span className="text-primary-500">*</span>
                </label>
                <select
                  id="cooperation_type"
                  name="cooperation_type"
                  required
                  className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-950 focus:outline-none focus:border-primary-500 transition-colors cursor-pointer"
                >
                  <option value="">请选择合作类型</option>
                  <option value="广告投放">广告投放</option>
                  <option value="品牌合作">品牌合作</option>
                  <option value="内容授权">内容授权</option>
                  <option value="媒体合作">媒体合作</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-foreground-700 text-sm font-medium mb-2">
                  合作说明 <span className="text-primary-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors resize-none"
                  placeholder="请描述您的合作需求（500字以内）"
                ></textarea>
                <p className="text-foreground-400 text-xs mt-1">限500字以内</p>
              </div>

              {/* Anti-spam honeypot */}
              <div className="spambot-field">
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>

              <button
                type="submit"
                disabled={formStatus === 'loading'}
                className="w-full px-6 py-3.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {formStatus === 'loading' ? '提交中...' : '提交合作需求'}
              </button>

              {formStatus === 'success' && (
                <div className="p-4 bg-green-50 border border-green-200 rounded-lg text-green-700 text-sm">
                  提交成功！我们将在24小时内通过邮箱与您联系。
                </div>
              )}
              {formStatus === 'error' && formError && (
                <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  {formError}
                </div>
              )}
            </form>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="p-5 bg-background-100 rounded-lg">
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-lg text-primary-600"></i>
                </div>
                <h4 className="text-foreground-950 text-sm font-medium mb-1">商务邮箱</h4>
                <p className="text-foreground-500 text-xs">hello@smallbar.cn</p>
              </div>
              <div className="p-5 bg-background-100 rounded-lg">
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-wechat-line text-lg text-accent-600"></i>
                </div>
                <h4 className="text-foreground-950 text-sm font-medium mb-1">官方微信</h4>
                <p className="text-foreground-500 text-xs">51在线吃瓜官方</p>
              </div>
              <div className="p-5 bg-background-100 rounded-lg">
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-phone-line text-lg text-secondary-600"></i>
                </div>
                <h4 className="text-foreground-950 text-sm font-medium mb-1">客服热线</h4>
                <p className="text-foreground-500 text-xs">400-888-5151</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Download */}
        <section className="relative w-full min-h-[400px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20wide%20panoramic%20abstract%20composition%20with%20warm%20gradients%20from%20deep%20charcoal%20to%20rich%20coral%20and%20amber%20tones%20soft%20diffused%20ambient%20light%20modern%20minimalist%20style%20cinematic%20atmosphere%20suitable%20for%20background%20no%20text%20no%20people%20just%20atmospheric%20color%20gradients&width=1600&height=600&seq=cta-about-download&orientation=landscape"
              alt="下载51在线吃瓜APP"
              title="51在线吃瓜app下载"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-3xl md:text-5xl font-heading text-background-50 leading-tight mb-6">
                加入5000万吃瓜大军
              </h2>
              <a
                href="#"
                className="inline-flex items-center gap-3 px-8 py-3.5 bg-background-50 text-foreground-950 rounded-full text-sm font-medium hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <span>立即下载APP</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-950">
                  <i className="ri-arrow-right-line text-background-50 text-sm"></i>
                </div>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}